// extracted by mini-css-extract-plugin
export default {"countdown":"Gca-z","srOnly":"Hca-z"};